import { StoreBase } from '@/store/base/StoreBase'
import { ModalType } from '@/router'

export interface ModalStoreState {
  activeModal: ModalType;
  /**
   * Заголовок для модалок, текст которых зависит от ответа сервера.
   * Пустая строка — модалка показывает свой текст по умолчанию.
   */
  modalMessage: string;
}

export class ModalStore extends StoreBase<ModalStoreState> {
  public static getNamespace(): string {
    return 'modals'
  }

  constructor() {
    super(ModalStore.getNamespace())
  }

  public static get(): {
    modalStore: ModalStore;
    modalState: ModalStoreState;
  } {
    const namespace = this.getNamespace()

    if (!this._hasModule(namespace)) {
      this._register<ModalStoreState>(namespace, {
        activeModal: ModalType.none,
        modalMessage: '',
      })
    }

    const store = new ModalStore()

    return {
      modalStore: store,
      modalState: store.state,
    }
  }
}
